import { Injectable } from '@angular/core';
import * as $ from 'jquery';

@Injectable()
export class ScrollAppService {
  constructor() {}
  public scrollToId(id: string, topV= -0, speed= 300) {
    // Si no existe retorno falso
    if ($('#' + id).length === 0) { return false; }
    $('html, body').stop().animate({
      scrollTop: $('#' + id).offset().top + topV
    }, speed);
  }
}
